import SavingsComparisonTable from '@/components/businessValue/SavingsComparisonTable';
import CumulativeSavingsChart from '@/components/businessValue/CumulativeSavingsChart';

export default function SavingsCharts({ data }) {
  if (!data) return null;

  return (
    <div className="space-y-4">
      <SavingsComparisonTable savings={data} />
      <CumulativeSavingsChart savings={data} />
    </div>
  );
}
